var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartBarVertical01SvgrepoCom12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C2FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 13.1458V22.3333M9.125 13.1458H4.63294C4.06122 13.1458 3.77564 13.1458 3.55727 13.2571C3.36519 13.355 3.20914 13.511 3.11126 13.7031C3 13.9215 3 14.2075 3 14.7793V22.3333H9.125M9.125 13.1458V7.63344C9.125 7.06171 9.125 6.77564 9.23626 6.55727C9.33414 6.36519 9.49019 6.20914 9.68227 6.11126C9.90064 6 10.1863 6 10.7579 6H13.6163C14.188 6 14.4745 6 14.6928 6.11126C14.8848 6.20914 15.0405 6.36519 15.1383 6.55727C15.2496 6.77564 15.25 7.06172 15.25 7.63344V10.0833M9.125 22.3333H15.25M15.25 10.0833H19.7417C20.3134 10.0833 20.6001 10.0833 20.8184 10.1946C21.0105 10.2925 21.1655 10.4485 21.2633 10.6406C21.3746 10.859 21.375 11.1451 21.375 11.7168V22.3334L15.25 22.3333M15.25 10.0833V22.3333",
    stroke: "#1F243B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 4,
    r: 4,
    fill: "#EE2738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarVertical01SvgrepoCom12);
export default __webpack_public_path__ + "static/media/chart-bar-vertical-01-svgrepo-com 1 (2).decb65b729198e9304681c639ea49343.svg";
export { ForwardRef as ReactComponent };